import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section className="w-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white pt-28 pb-20">
      <div className="max-w-7xl mx-auto px-6 text-center">
        
        {/* Animated Heading */}
        <motion.h1
          className="text-5xl md:text-6xl font-extrabold leading-tight mb-6"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Your Virtual Keyboard, <br /> Anytime. Anywhere.
        </motion.h1>

        {/* Subtext */}
        <motion.p
          className="text-lg md:text-xl text-gray-200 mb-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          Type using just your camera and hand gestures.  
          No hardware, no hassle — just open and start typing.
        </motion.p>

        
      </div>
    </section>
  );
}
